import { Lesson } from "@jelly/lesson";
import { task as task01 } from "../../../task/course-02/lesson-19/task-01";
import principle01 from "./layouts/principle-01/principle";

const lesson: Lesson = {
  id: "f95203e7-0946-4a0b-ba9e-28ecb546405c",
  publicId: "19",
  name: "Speech in reverberation and noise",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },

  body: [
    principle01,
    {
      title: `In the context of room acoustics, what does 20 Hz correspond to?`,
      description: "Select the correct answer(s).",
      layout: {
        type: "simple",
        options: {
          components: {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        },
      },
    },
  ],
};

export default lesson;
